import React from "react"
import Masonry from "react-masonry-css"
import AuctionCard from "../AuctionCard/AuctionCard"

import * as styles from "./MasonryGrid.module.scss"

const MasonryGrid = ({ data }: any) => {
  const breakpointColumnsObj = {
    default: 4,
    1200: 3,
    900: 2,
    700: 1,
  }

  return (
    <>
      <Masonry
        breakpointCols={breakpointColumnsObj}
        className={styles.myMasonryGrid}
        columnClassName={styles.myMasonryGrid_column}
      >
        {data.map((obj, i) => (
          <AuctionCard key={i} data={obj.node ? obj.node : obj} />
        ))}
      </Masonry>
    </>
  )
}

export default MasonryGrid
